import React from 'react';
import {
  TemplateNamesByValueByVariable,
  VariableModel,
} from '../../iasConfigSchema';
import AzureEntraIdUserWidget from '../widgets/AzureEntraIdUserWidget';
import DefaultWidget from '../widgets/DefaultWidget';
import UnknownVariableWidget from './UnknownVariableWidget';
import EnumWidget from '../widgets/EnumWidget';
import BooleanWidget from '../widgets/BooleanWidget';
import NumberWidget from '../widgets/NumberWidget';
import GitLabGroupWidget from '../widgets/GitLabGroupWidget';
import { useWatch } from 'antd/es/form/Form';

type Props = {
  variable: VariableModel;
  templateName: string;
  usedUniqueValues: TemplateNamesByValueByVariable;
};

const Variable: React.FC<Props> = ({
  variable,
  templateName,
  usedUniqueValues,
}) => {
  const values = useWatch([['variables']]);

  const enabled =
    variable.enabled_if?.every((dependency) => !!values?.[dependency]) ?? true;

  switch (variable.type) {
    case 'azure-entra-id-user':
      return <AzureEntraIdUserWidget variable={variable} disabled={!enabled} />;
    case 'gitlab-group':
      return <GitLabGroupWidget variable={variable} disabled={!enabled} />;
    case 'string':
      return (
        <DefaultWidget
          variable={variable}
          disabled={!enabled}
          templateName={templateName}
          usedUniqueValues={usedUniqueValues}
        />
      );
    case 'int':
    case 'float':
      return <NumberWidget variable={variable} disabled={!enabled} />;
    case 'bool':
      return <BooleanWidget variable={variable} disabled={!enabled} />;
    case 'enum':
      return <EnumWidget variable={variable} disabled={!enabled} />;
    default:
      return <UnknownVariableWidget variable={variable} />;
  }
};

export default Variable;
